<template>
<div style="height:100%;overflow:auto">
        <div ref="fadeWhenModelOpen" class="mt-3">
        <div class="m-4 d-flex" style="border-bottom: 1px solid #242424;position:relative">
            <h6 class="m-0 text-left pl-4">{{$t('For Bins')}}</h6>
        </div>
        <div class="d-inline-flex w-100 float-left" style="padding: 0px 10px 0px 10px;">
                <label style="width:16%;text-align:end" class="text-color">{{$t('Default Retrieval Path')}}</label>
                <div style="margin:0px 9px 9px 12px;width:83%">
                    <div style="display:inline-block;text-align: initial;width:100%;">
                        <input type="text" v-model="retrieveSettings.retrieval_path" v-if="retrieveSettings.retrieval_path != undefined && retrieveSettings.retrieval_path.length" :style="{width:((retrieveSettings.retrieval_path.length+1)*8) + 'px'}" class="rounded text-light non-editable-field text-light" placeholder="select retrieve path from browse"/>
                        <span v-else class="empty-field-text-styles mr-2">NONE</span>
                        <browse-icon v-on:click.native="openAddBinsBrowser()" style="height:26px;margin-inline-start:3px;position: relative;bottom: 5px;"></browse-icon>
                        <div class="config-desc">
                            {{$t('Destination path for media retrieval')}}
                        </div>
                    </div>
                </div>
        </div>
        <div class="d-inline-flex w-100 float-left" style="width: 83%;display: inline-block;padding: 20px 10px 0px 10px;">
            <label style="width:16%;text-align:end;line-height:25px;" class="text-color">{{$t('Retrieve With')}}</label>
            <div style="width: 83%;display: inline-block;">
                <ul class="d-inline-block float-left pl-0 mb-2" style="list-style-type:none;margin:0px 9px 9px 12px">
                    <li class="d-inline-block float-left w-100" style="margin-inline-start:0px !important">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateRetrieveSettings('category_structure',$event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="customSwitch1"
                                :checked='retrieveSettings.category_structure'/>
                            <label class="custom-control-label" for="customSwitch1">{{$t('Catalog Folder Structure')}}</label>
                        </div>
                        <div class="config-desc">
                            {{$t('Upon file retrieval')}}, {{$t('the file catalog structure is created at the specified bin path')}}.
                        </div>
                    </li>
                    <li class="d-inline-block float-left w-100 mb-2" style="margin-inline-start:0px !important">
                        <div class="custom-control custom-switch">
                            <input
                                v-on:click="updateRetrieveSettings('date_structure',$event.target.checked)"
                                type="checkbox"
                                class="custom-control-input"
                                id="customSwitch2"
                                :checked='retrieveSettings.date_structure'/>
                            <label class="custom-control-label" for="customSwitch2">{{$t('Date Folder Structure')}}</label>
                        </div>
                        <div class="config-desc">
                            {{$t('Upon file retrieval')}}, {{$t('a folder structure with today')}}'{{$t('s date is created at the specified bin path')}}.
                            <div><b>{{$t('Example')}}:</b>  {{$t('If the default retrieval path is set as')}} '{{$t('Retrieve')}}', {{$t('and today')}}'{{$t('s date is January')}} 1 2000, {{$t('then the file retrieval path will be')}} <b>Share://Retrieve/Jan-2000/01-01-2020/</b> .</div>
                        </div>
                    </li>
                </ul>
            </div>    
        </div>

        <div class="m-4" style="border-bottom: 1px solid #242424;position:relative;display:inline-block;width:100%;">
            <h6 class="m-0 text-left pl-4">{{$t('For Catalogs')}}</h6>
        </div>
        <div class="d-inline-flex w-100 float-left" style="padding: 0px 10px 0px 10px;">
            <label style="width:16%;text-align:end" class="text-color">{{$t('Default Catalog')}}</label>
            <div style="margin:0px 9px 9px 12px;width:83%">
                <div style="display: grid;" > <!--padding-inline-start: 25px; -->
                    <div class="d-inline-flex">
                        <input type="radio" value="catalog_id_path" v-model="pathTypesStrategy" @change="updateRetrieveSettings('parent_catalog_structure', $event.target.checked)" class="bg-transparent border rounded text-light bigger-checkboxes" name="catalog path"/>
                        <label class="filter-label">{{$t('Follow Parent Catalog Structure')}}</label>
                    </div>
                    <div class="config-desc">
                        {{$t('The retrieved file catalog will be its parent catalog')}}.
                    </div>
                    <div class="d-inline-flex" style="margin-top: 10px;">
                        <input type="radio" value="bin_id_path" v-model="pathTypesStrategy" @change="updateRetrieveSettings('source_file_path_catalog_structure', $event.target.checked)" class="bg-transparent border rounded text-light bigger-checkboxes" name="folder path"/>
                        <label class="filter-label">{{$t('Follow Source File Path Catalog Structure')}}</label>
                    </div>
                    <div class="config-desc">
                        {{$t("On 'Retrieve As', the retrieved file catalog will be the retrieved file path")}},Ex: if file is retrieved to share://retrieve/rushes/bombay/file.mp4 {{$t('then its catalog will be')}} catalog://retrieve/rushes/bombay
                    </div>
                </div>
            </div>
        </div>

        <template v-if="isEnabled('manage-pools')">
            <div class="mt-4 mb-2 ml-4" style="border-bottom: 1px solid #242424;position:relative">
                <h6 class="m-0 text-left pl-4">{{$t('From Devices')}}</h6>
            </div>
            <div class="d-inline-flex w-100" style="padding: 0px 10px 0px 10px;">
                <label style="width:16%;text-align:end" class="text-color mt-3">{{$t('Device priority')}}</label>
                <div class="value-style d-inline-flex bg-transparent rounded text-light input-fields searched-metadata-display-fields"
                style="margin-top:5px;width:700px;padding-inline-start: 7px;">
                    <div v-if="!poolDevicesArr.length" class="config-desc" style="padding: 11px;">{{$t('No devices found')}}</div>
                    <ul v-else class="tags-display-ul p-0 w-100 m-0" style=" display: grid;">
                    <div style="display: grid;">
                        <draggable
                            :list="poolDevicesArr"
                            :disabled="false"
                            class="list-group"
                            ghost-class="ghost"
                            :move="checkMove"
                            @start="dragging = true"
                            @end="dragging = false;updatePriorityOfRetrieve()"
                        >
                            <template v-for="pool in poolDevicesArr">
                                <div class="list-group-item view-tags" style="color:#EEEEEE" :key="pool._id">
                                    <div class="screen-tags-name-display">
                                        <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-list drag-icon" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                                        </svg >
                                        </div>
                                        <div style="margin-inline-start: 5px !important" class="screens-name-styles">{{pool.device_id}}</div>
                                    </div>
                                </div>
                            </template>
                        </draggable>
                    </div>
                    </ul>
                </div>
            </div>
        </template>
    </div>
    <bins-browse-modal
      v-if="isModalVisible"
      :workspaceList="browseWorkspaceList"
      :enableAssetMultiSelect="false"
      @close="closeModal"
      @handleFilesBrowse="selectedBinPath"
      :enableRecursive="false"
      :browseOnlyFolders="true"
      style="z-index:99"
      :parentPreSelectedPathIds="[retrieveSettings.retrieval_path]"
    ></bins-browse-modal>
</div>
</template>


<script>
import fileBrowseModel from "../files/filesBrowse.vue";
import browseIcon from "../core/InlineBrowseField.vue";
import {mapActions, mapMutations, mapGetters} from "vuex";
import Utils from "../../components.utils.js";
import Constants from "../../components.constants.js";
import draggablePlugin from "vuedraggable";


export default {
    data(){
        return{
            isModalVisible:false,
            retrieveSettings:{},
            poolDevicesArr:[],
            browseWorkspaceList:[Constants.WORKSPACE_BINS],
            pathTypesStrategy:null
        }
    },
    computed: {
      ...mapGetters("users", ["getLoggedInUserPrivilege",]),
      draggingInfo() {
        return this.dragging ? "under drag" : "";
      }
    },
    components:{
      "browse-icon" : browseIcon,
      "bins-browse-modal": fileBrowseModel,
      "draggable": draggablePlugin,
    },
    methods:{
        checkMove: function(e) {
            window.console.log("Future index: " + e.draggedContext.futureIndex);
        },
        isEnabled(priv) {
         return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, priv);
        },
        updatePriorityOfRetrieve(){
            for(let i = 0 ; i < this.poolDevicesArr.length; i++){
                this.poolDevicesArr[i].priority = i+1;
            }
            let payload = {"devices":this.poolDevicesArr};
            this.updatePoolPriority(payload).then((data) => {
               if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    if (data.message.includes("Failed")) {
                        this.$toast.warning(data.message);
                    } else {
                        this.$toast.success(data.message);
                    }
                } else {
                this.$toast.error(data.message);
                }
            })
        },
        openAddBinsBrowser(){
          this.isModalVisible = true;
          this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
        },
         closeModal() {
              this.isModalVisible = false;
              this.$refs.fadeWhenModelOpen.style.opacity = 1;
        },
        selectedBinPath(folderInfoList){
          if(folderInfoList && folderInfoList.length > 0){
            this.retrieveSettings.retrieval_path = folderInfoList[0].path;
            this.updateRetrieveSettings("retrieval_path",this.retrieveSettings.retrieval_path)
            this.closeModal();
          }else{
            console.log("Failed to update the browsed folder path:",folderInfoList)
          }
        },
        updateRetrieveSettings(key,value){
            let payload={};
            payload["_id"] = this.retrieveSettings["_id"];
            payload["setting_name"] = 'Retrieval Setting';
            payload["setting_type"] = 'retrieval';
            if(key == "parent_catalog_structure"){
                payload['parent_catalog_structure'] = value;
                payload['source_file_path_catalog_structure'] = !value
                this.retrieveSettings['parent_catalog_structure'] = value;
                this.retrieveSettings['source_file_path_catalog_structure'] = !value;
                // this.pathTypesStrategy = "catalog_id_path";
            }else if(key == 'source_file_path_catalog_structure'){
                payload['source_file_path_catalog_structure'] = value;
                payload['parent_catalog_structure'] = !value;
                this.retrieveSettings['source_file_path_catalog_structure'] = value;
                this.retrieveSettings['parent_catalog_structure'] = !value;
                // this.pathTypesStrategy = "bin_id_path";
            }else{
                payload[key] = value;
            }
            setTimeout(() => {
            this.updateSettingsKeys(payload).then((data) => {
               if (Utils.isAcceptedStatusCode(data.statusCode)) {
                    if (data.message.includes("Failed")) {
                        this.$toast.warning(data.message);
                    } else {
                        this.$toast.success(data.message);
                    }
                } else {
                this.$toast.error(data.message);
                }
            });
            }, 200);
        },
        updateSourcePathStruct(){
            if(this.pathTypesStrategy == "catalog_id_path"){
                this.retrieveSettings['parent_catalog_structure'] = true;
                this.retrieveSettings['source_file_path_catalog_structure'] = false;
            }else{
                this.retrieveSettings['source_file_path_catalog_structure'] = true;
                this.retrieveSettings['parent_catalog_structure'] = false;
            }
        },
        updateRetreiveFields(notification){
            notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            let notificationMessage = notification.message
            if('parent_catalog_structure' in notificationMessage && notificationMessage.parent_catalog_structure){
                this.pathTypesStrategy = "catalog_id_path";
            }else{
                this.pathTypesStrategy = "bin_id_path";
            }
            this.updateSourcePathStruct();
            this.retrieveSettings.category_structure = notificationMessage.category_structure;
            this.retrieveSettings.date_structure = notificationMessage.date_structure;
            this.retrieveSettings.retrieval_path = notificationMessage.retrieval_path;

        },
        ...mapActions("pools",["getPoolDevices","updatePoolPriority"]),
        ...mapActions("settings", ["getRetrieveSettingsDetailsFromServer","updateSettingsKeys"]),
        ...mapMutations("registry",["loadExternalPluginForSystemSettingsMenu"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    },
    created(){
        this.getRetrieveSettingsDetailsFromServer().then((data)=>{
            if(data.retrieval_settings.length){
                this.retrieveSettings = data.retrieval_settings[0];//given this only for retrieve settings, handle it when tabs comes
                if('parent_catalog_structure' in this.retrieveSettings && this.retrieveSettings.parent_catalog_structure){
                    this.pathTypesStrategy = "catalog_id_path"
                }else{
                    this.pathTypesStrategy = "bin_id_path"
                }
                this.updateSourcePathStruct();
            }
        })

        this.getPoolDevices().then((data)=>{
            this.poolDevicesArr = data.devices;
            console.log("dataaaaaaaaaaaaaaaaa",this.poolDevicesArr);
        })

        this.addWSEventListener({eventname:Constants.retreiveSettingsNotification, callback:this.updateRetreiveFields, parent:"retrievesettings"});
    },
    beforeDestroy(){
        this.removeWSEventListener({eventname:Constants.retreiveSettingsNotification, callback:this.updateRetreiveFields, parent:"retrievesettings"});
    },
    mounted() {
    },
}
</script>

<style lang="scss" scoped>
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;


input[type='checkbox']:after{
    line-height: 1.5em;
    content: '';
    display: inline-block;
    width: 22px;
    height: 21px;
    margin-top: 5px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: 0.25em;
    background: $primary-background;
}

input[type='checkbox']:checked:after{
    content: '✔';
    color: $active-blue !important;
    // position: absolute;
    font-size: 16px;
    line-height: 1;
    transition: all .2s;
    font-family: Helvetica, Arial, sans-serif;
    padding-inline-start: 4px;
    padding-top:2px;
}

.text-color{
  color:$dull-text-color;
  line-height:20px;
}

.bigger-checkboxes{
    height: 30px;
    width: 20px;
}
li{
    margin:0px 9px 9px 9px;
}
.border {
    border: $border-color !important;
}
.config-desc{
  color: $dull-text-color;
}
.field-description {
  font-size: 11px;
  color: $dull-text-color;
}
.comm-input-field-style{
    background: $primary-background!important;
    width: 35% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}
.custom-control-label{
    line-height:25px;
}

.non-editable-field{
    border: none !important;
    pointer-events: none;
    cursor: default;
    position: relative;
    bottom: 4px;
}

.config-desc,.custom-control{
  width: 100%;
  text-align: initial;
}

.empty-field-text-styles{
  color:$none-text-color;
}
.custom-switch .custom-control-label::before{
    background: transparent;
}
.custom-control-input:checked~.custom-control-label:before {
    color: #fff;
    border-color: #007bff;
    background-color: #007bff !important;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.view-tags {
    font-size: 12px!important;
    display: inline-flex!important;
    margin: 6px!important;
    border-radius: 15px!important;
    text-align: start;
    padding: 7px!important;
    justify-content: space-between;
    background:$primary-background;
    border:$border-color;
  span {
    margin-inline-start: 0px !important;
    font-size: 12px !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
    width: 90%;
  }
}

.screen-tags-name-display{
  display:inline-flex;
  line-height:44px;
  width:33%;
}

.drag-icon{
  color:$dull-text-color;
  cursor: grab;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

input[type="radio"] {
    /* background-color only for content */
    background-color:$primary-background !important;
  }
  
  /* appearance for checked radiobutton */
  input[type="radio"]:checked {
    background-color: $active-blue !important;
    //background-image: linear-gradient(to bottom, #5294ce, #3176b3) !important;
    background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
    border: 1px solid $active-blue !important;
  }

input[type="radio"] {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    padding: 4px;
    border-radius: 50% !important;
    width: 20px;
    height: 20px;
    border: 1px solid #4a4a4a !important;
}

.filter-label{
  position: relative;
  bottom: 0px;
  padding-inline-start:8px;
  margin-bottom:0px !important;
}
</style>